import React, { useState, useEffect, useRef } from "react";
import Loader from "../../components/loader";

import UiTable from "../../components/table/Table";
import WalletConnect from "../../components/common/walletConnect/index";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import {
  useGetUserMarginCollateral,
  useGetUserMarginPnl,
} from "../../context/contractDataLoaderService";
import {
  contractAddress,
  MarginIssueManager,
} from "@verified-network/verified-sdk";
import { usePDF } from "react-to-pdf";
import { useReactToPrint } from "react-to-print";
import { filterWithDate } from "../../utils/constants";
import VerticallyModal from "../../components/modal/VerticallyModal";
import { Col, Row } from "react-bootstrap";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import UiButton from "../../components/button";
import { useGlobal } from "../../context/globalContext";

function PnlPage(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  let marginManagerContract;
  if (provider && provider.getSigner && chainId && address) {
    if (contractAddress[chainId].BalancerMarginIssueManager) {
      marginManagerContract = new MarginIssueManager(
        signer,
        contractAddress[chainId].BalancerMarginIssueManager,
      );
    }
  }

  let { allPnls: data, loading: loading } = useGetUserMarginPnl();
  const { toPDF, targetRef } = usePDF({
    filename: `my verified p&l ${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}.pdf`,
  });
  const [startDate, onChangeStartDate] = useState(new Date());
  const [endDate, onChangeEndDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [modalView, setModalView] = useState(0);
  const [tableData, setTableData] = useState(null);
  const modalContent = useRef(null);
  const componentToPrintRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
  });

  const headers = [
    { label: "Date(UTC)", val: "date" },
    { label: "Currency", val: "currencySymbol" },
    { label: "Dividend", val: "dividend" },
    { label: "Security", val: "securitySymbol" },
    { label: "Financing", val: "financing" },
    { label: "Commission", val: "commission" },
  ];

  const handleModalHide = () => {
    setShowModal(false);
    setShowModal(0);
  };

  const commonProps = {
    modalView,
    updateModalView: setModalView,
    showModal,
    updateShowModal: setShowModal,
    tableData,
    updateTableData: setTableData,
    targetRef: targetRef,
    toPDF: toPDF,
    componentToPrintRef: componentToPrintRef,
    handlePrint: handlePrint,
  };

  let message, heading;
  if (modalView === 10) {
    heading = "Custom Filter";
    message = (
      <>
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>From</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DateTimePicker
                  onChange={onChangeStartDate}
                  value={startDate}
                />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>To</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DateTimePicker onChange={onChangeEndDate} value={endDate} />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0">
                <UiButton
                  onClick={() => {
                    if (data.length > 0) {
                      setTableData(
                        filterWithDate(data, "date", startDate, endDate),
                      );
                    }
                    handleModalHide();
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Filter"
                  type="submit"
                />
              </Col>
            </Row>
          </Row>
        </div>
      </>
    );
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-100">
            <h3 className="text-left">Margin Profit and Loss</h3>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={tableData ? tableData : data ? data : []}
            hover
            provider={provider}
            web3={web3}
            account={account}
            chainId={chainId}
            contract={marginManagerContract}
            bordered={false}
            commonProps={commonProps}
            showFilter={true}
          />
        </div>
      </section>
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={handleModalHide}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>{heading}</b>
          </h2>
        }
        withFooter={false}
      >
        {message}
      </VerticallyModal>
      <WalletConnect loggedIn={props.loggedIn} />
    </>
  );
}

export default function Pnls(props) {
  return <PnlPage {...props} />;
}
